import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem, TextField } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import api from "../../API";
import TaskSelectDialogPage from "./task/TaskSelectDialogPage"
import Task01ListPage from "./task/task-01/Task01ListPage";
import Task02ListPage from "./task/task-02/Task02ListPage";
import Task03ListPage from "./task/task-03/Task03ListPage";
import Task04ListPage from "./task/task-04/Task04ListPage";
import Task05ListPage from "./task/task-05/Task05ListPage";
import Task06ListPage from "./task/task-06/Task06ListPage";
import Task07ListPage from "./task/task-07/Task07ListPage";
import Task08ListPage from "./task/task-08/Task08ListPage";
import Task09ListPage from "./task/task-09/Task09ListPage";
import Task10ListPage from "./task/task-10/Task10ListPage";
import { SearchBackDrop } from "../component/common/SearchBackDrop";

interface UseCheckCntType {
  t_cnt: number;
  c_cnt: number;
  f_cnt: number;
}

// const initail_img_cnt: any = {
//   img_2_cnt:  0,
//   img_1_cnt:  0,
//   img_0_cnt:  0
// }

const initailData_use_check: UseCheckCntType = {
  t_cnt: 0,
  c_cnt: 0,
  f_cnt: 0
};

const VieWorkerPage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let manager_role = auth.user.roles.some((obj:any) => ['VIE_MANAGER'].includes(obj.role));

  // const [isp_mode , setIsp_mode] = useState<boolean>(manager_role);

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)
  
  const [taskSelectPageOpen , setTaskSelectPageOpen] = useState<boolean>(false);
  const [task, setTask] = useState("01");

  const [sub_code, setSub_code] = useState("");

  const [work_yn, setWork_yn] = useState("모두");

  const [use_check, setUse_check] = useState("모두");

  const [workList, setWorkList] = useState([]);

  const [use_check_cnt, setUse_check_cnt] = useState<UseCheckCntType>(initailData_use_check);

  // const [img_cnt_status, setImg_cnt_status] = useState<any>(initail_img_cnt);

  const [page, setPage] = useState(1);
  
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const goTask = (task: string) => {
    setTask(task);
    vieWorkList(work_yn,use_check,task)
  };

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const vieWorkList = async (work_yn:string, use_check:string, task:string) => {
    let url = ''
    if(task=="01") {url = '/vie-01-workList'}
    else if(task=="02") {url = '/vie-02-workList'}
    else if(task=="03") {url = '/vie-03-workList'}
    else if(task=="04") {url = '/vie-04-workList'}
    else if(task=="05") {url = '/vie-05-workList'}
    else if(task=="06") {url = '/vie-06-workList'}
    else if(task=="07") {url = '/vie-07-workList'}
    else if(task=="08") {url = '/vie-08-workList'}
    else if(task=="09") {url = '/vie-09-workList'}
    else if(task=="10") {url = '/vie-10-workList'}

    setBackdrop(true)
    api.get(url,{params:{email:email,page:page,worker:worker,work_yn:work_yn,use_check:use_check,manager_role:manager_role,sub_code:sub_code}})
    .then((res:any) => {
      
      // console.log('리턴 데이터', res.data)
      if(res.data.datas.length > 0){
        // setWorkList(res.data);
        // setData(res.data.datas[0]);
        setWorkList(res.data);
        setTotal_cnt(res.data.pagination.total_count)
        setUse_check_cnt(res.data.use_check_cnt)

        // if(task=="10"){
        //   setImg_cnt_status(res.data.img_status)
        // }
      }else{
        // console.log('api 리턴 데이터', res.data)
        setWorkList(res.data);
        setTotal_cnt(0)
      }
      setBackdrop(false)
      // setPagination(res.data.pagination); 
      })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const getAuth = async () => {
    if(!email){ nav('/') }
    api.get('/@me',{params:{email:email}})
    .then((resp:any) => {dispatch(setUserInfo(resp.data)); console.log('/@me',resp.data) })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  useEffect(() => {
    getAuth()
    vieWorkList(work_yn,use_check,task)
  },[page,task])

  return (
    <Box>
      {backdrop && ( <SearchBackDrop/> )}
      {/* 상단 메뉴 */}
      <Box display="flex" sx={{padding:"4px 8px 8px 8px"}}>
      {manager_role ? <Box display="flex">
          <Button variant="contained" size="small" sx={{fontWeight:700, margin:"4px 8px", marginLeft:"auto", backgroundColor:"red"}} onClick={() => {}} >
              검수자
          </Button>
        </Box> : ""}
        <Box display="flex">
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px",alignSelf: "center"}}>작업할당 목록 (<b style={{color:"#1976d2"}}>{total_cnt != 0 ? total_cnt:0}</b> 건)</Box>
          <Button variant="contained" size="small" sx={{fontWeight:700, margin:"4px 8px", marginLeft:"auto"}}
              onClick={() => {
                setTaskSelectPageOpen(true)
              }}
            >
              Task 변경
          </Button>
          {taskSelectPageOpen ? <TaskSelectDialogPage email={email} task={task} goTask={goTask} setTask={setTask} setTaskSelectPageOpen={setTaskSelectPageOpen} /> : <></>}
        </Box>
        <Box display="flex" sx={{alignItems: "center", justifyContent: "right"}}>
          <Box sx={{marginLeft: "16px", fontSize:"16px"}}>작업상태</Box>
          <Select id="work_yn" value={work_yn} onChange={(e)=> { setWork_yn(e.target.value); vieWorkList(e.target.value,use_check,task);}} sx={{width:"128px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            <MenuItem dense value={"None"}>미작업</MenuItem>
            <MenuItem dense value={"Y"}>작업완료</MenuItem>
          </Select>
        </Box>
        <Box display="flex" sx={{marginLeft: "16px",alignItems: "center", justifyContent: "right"}}>
          <Box sx={{marginLeft: "16px", fontSize:"16px"}}>USE_CHECK</Box>
          <Select id="use_check" value={use_check} onChange={(e)=> { setUse_check(e.target.value); vieWorkList(work_yn,e.target.value,task);}} sx={{width:"128px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            <MenuItem dense value={"T"}>사용가능</MenuItem>
            <MenuItem dense value={"C"}>내용수정</MenuItem>
            <MenuItem dense value={"F"}>사용불가</MenuItem>
            <MenuItem dense value={"None"}>미분류</MenuItem>
          </Select>
          {task == "10" && 
          <>
            <Box sx={{marginLeft:"16px", marginRight:"20px", fontWeight:700, letterSpacing:"-2px",alignSelf: "center"}}>id</Box>
            <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                      value={sub_code} onChange={(e) => {setSub_code(e.target.value);}}
            // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
              InputProps={{
                style: {width: "100px", height:"30px", fontSize:"14px"},
                inputProps: { 
                  spellCheck: "false" // spellcheck를 false로 설정
                },
              }} 
            />
            <Button variant="contained" size="small" sx={{fontWeight:700, margin:"4px 8px", marginLeft:"auto", backgroundColor:"#2381fd"}}
                onClick={() => {
                  vieWorkList(work_yn,use_check,'10')
                }}
              >
                적용
            </Button>

            {/* <Box sx={{marginLeft: "8px", fontSize: "24px"}}>{"["}<b style={{color:"blue"}}>2:{img_cnt_status.img_2_cnt} </b>, <b style={{color:"green"}}>1:{img_cnt_status.img_1_cnt}</b>, <b style={{color:"red"}}>0:{img_cnt_status.img_0_cnt}</b>{"]"}</Box> */}
          </>
        }
          <Box sx={{marginLeft: "8px", fontSize: "24px"}}>{"["}<b style={{color:"blue"}}>T:{use_check_cnt.t_cnt} </b>, <b style={{color:"green"}}>C:{use_check_cnt.c_cnt}</b>, <b style={{color:"red"}}>F:{use_check_cnt.f_cnt}</b>{"]"}</Box>
        </Box>
      </Box>
      {/* 상단 메뉴 */}

      {/* Task 단위 화면 */}
      {task == "01" ? <Task01ListPage task={"01"} work_yn={work_yn} use_check={use_check} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/> : <></> }
      {task == "02" ? <Task02ListPage task={"02"} work_yn={work_yn} use_check={use_check} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/> : <></> }
      {task == "03" ? <Task03ListPage task={"03"} work_yn={work_yn} use_check={use_check} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/> : <></> }
      {task == "04" ? <Task04ListPage task={"04"} work_yn={work_yn} use_check={use_check} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/> : <></> }
      {task == "05" ? <Task05ListPage task={"05"} work_yn={work_yn} use_check={use_check} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/> : <></> }
      {task == "06" ? <Task06ListPage task={"06"} work_yn={work_yn} use_check={use_check} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/> : <></> }
      {task == "07" ? <Task07ListPage task={"07"} work_yn={work_yn} use_check={use_check} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/> : <></> }
      {task == "08" ? <Task08ListPage task={"08"} work_yn={work_yn} use_check={use_check} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/> : <></> }
      {task == "09" ? <Task09ListPage task={"09"} work_yn={work_yn} use_check={use_check} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/> : <></> }
      {task == "10" ? <Task10ListPage task={"10"} work_yn={work_yn} use_check={use_check} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/> : <></> }
      {/* Task 단위 화면 */}
    </Box>
  );
};

export default VieWorkerPage;
